export { default as PostSingle } from './PostSingle';